// FETCH ALL ACCESSORIES_REQUIREMENTS
export const FETCH_ACCESSORIES_REQUIREMENTS_REQUEST = 'FETCH_ACCESSORIES_REQUIREMENTS_REQUEST';
export const FETCH_ACCESSORIES_REQUIREMENTS_SUCCESS = 'FETCH_ACCESSORIES_REQUIREMENTS_SUCCESS';
export const FETCH_ACCESSORIES_REQUIREMENTS_FAILURE = 'FETCH_ACCESSORIES_REQUIREMENTS_FAILURE';

// CREATE ACCESSORIES_REQUIREMENTS
export const CREATE_ACCESSORIES_REQUIREMENTS_REQUEST = 'CREATE_ACCESSORIES_REQUIREMENTS_REQUEST';
export const CREATE_ACCESSORIES_REQUIREMENTS_SUCCESS = 'CREATE_ACCESSORIES_REQUIREMENTS_SUCCESS';
export const CREATE_ACCESSORIES_REQUIREMENTS_FAILURE = 'CREATE_ACCESSORIES_REQUIREMENTS_FAILURE';

// UPDATE ACCESSORIES_REQUIREMENTS
export const UPDATE_ACCESSORIES_REQUIREMENTS_REQUEST = 'UPDATE_ACCESSORIES_REQUIREMENTS_REQUEST';
export const UPDATE_ACCESSORIES_REQUIREMENTS_SUCCESS = 'UPDATE_ACCESSORIES_REQUIREMENTS_SUCCESS';
export const UPDATE_ACCESSORIES_REQUIREMENTS_FAILURE = 'UPDATE_ACCESSORIES_REQUIREMENTS_FAILURE';

// FETCH SINGLE STATE
export const FETCH_SINGLE_ACCESSORIES_REQUIREMENTS_REQUEST = 'FETCH_SINGLE_ACCESSORIES_REQUIREMENTS_REQUEST';
export const FETCH_SINGLE_ACCESSORIES_REQUIREMENTS_SUCCESS = 'FETCH_SINGLE_ACCESSORIES_REQUIREMENTS_SUCCESS';
export const FETCH_SINGLE_ACCESSORIES_REQUIREMENTS_FAILURE = 'FETCH_SINGLE_ACCESSORIES_REQUIREMENTS_FAILURE';

// DELETE ACCESSORIES_REQUIREMENTS
export const DELETE_ACCESSORIES_REQUIREMENTS_REQUEST = 'DELETE_ACCESSORIES_REQUIREMENTS_REQUEST';
export const DELETE_ACCESSORIES_REQUIREMENTS_SUCCESS = 'DELETE_ACCESSORIES_REQUIREMENTS_SUCCESS';
export const DELETE_ACCESSORIES_REQUIREMENTS_FAILURE = 'DELETE_ACCESSORIES_REQUIREMENTS_FAILURE';

// FETCH ALL ACCESSORIES_REQUIREMENT BY STYLE DETAIL ID
export const FETCH_ACCESSORIES_REQUIREMENT_BY_STYLE_DETAIL_ID_REQUEST = 'FETCH_ACCESSORIES_REQUIREMENT_BY_STYLE_DETAIL_ID_REQUEST';
export const FETCH_ACCESSORIES_REQUIREMENT_BY_STYLE_DETAIL_ID_SUCCESS = 'FETCH_ACCESSORIES_REQUIREMENT_BY_STYLE_DETAIL_ID_SUCCESS';
export const FETCH_ACCESSORIES_REQUIREMENT_BY_STYLE_DETAIL_ID_FAILURE = 'FETCH_ACCESSORIES_REQUIREMENT_BY_STYLE_DETAIL_ID_FAILURE';

export const RESET_ACCESSORIES_REQUIREMENTS_INFO = 'RESET_ACCESSORIES_REQUIREMENTS_INFO';

export const CREATE_ACCESSORIES_REQUIREMENTS_FORM = 'CREATE_ACCESSORIES_REQUIREMENTS_FORM';

export const UPDATE_ACCESSORIES_REQUIREMENTS_FORM = 'UPDATE_ACCESSORIES_REQUIREMENTS_FORM';

export const RESPONSE_ACCESSORIES_REQUIREMENTS = 'RESPONSE_ACCESSORIES_REQUIREMENTS';

//FETCH INVOICE DATA
export const FETCH_ACCESSORIES_REQUIREMENT_INVOICE_REQUEST = 'FETCH_ACCESSORIES_REQUIREMENT_INVOICE_REQUEST';
export const FETCH_ACCESSORIES_REQUIREMENT_INVOICE_SUCCESS = 'FETCH_ACCESSORIES_REQUIREMENT_INVOICE_SUCCESS';
export const FETCH_ACCESSORIES_REQUIREMENT_INVOICE_FAILURE = 'FETCH_ACCESSORIES_REQUIREMENT_INVOICE_FAILURE';

export const RESET_ACCESSORIES_REQUIREMENT_INVOICE = 'RESET_ACCESSORIES_REQUIREMENT_INVOICE';

export const GET_SINGLE_EDIT_CHECK_GET_REQUEST = 'GET_SINGLE_EDIT_CHECK_GET_REQUEST';
export const GET_SINGLE_EDIT_CHECK_GET_SUCCESS = 'GET_SINGLE_EDIT_CHECK_GET_SUCCESS';
export const GET_SINGLE_EDIT_CHECK_GET_FAILURE = 'GET_SINGLE_EDIT_CHECK_GET_FAILURE';
